export const FIELD_DEFAULT_FONT_SIZE = 12
export const FIELD_DEFAULT_POSITION_X = 50
export const FIELD_DEFAULT_POSITION_Y = 50
export const FIELD_MIN_WIDTH = 100
export const FIELD_DEFAULT_HEIGHT = 32
export const CHECKBOX_DEFAULT_SIZE = 24
export const TEXT_FIELD_DEFAULT_WIDTH = 160
export const DATE_FIELD_DEFAULT_WIDTH = 140
export const SELECT_FIELD_DEFAULT_WIDTH = 250
export const NUMERIC_FIELD_DEFAULT_WIDTH = 80
export const SWITCH_FIELD_DEFAULT_WIDTH = 85
export const AUTOCOMPLETE_FIELD_DEFAULT_WIDTH = 260
export const IMAGE_DEFAULT_SIZE = 100

export const STATUSES = {
  new: 'new',
  created: 'created',
  to_delete: 'to_delete'
}

export const TYPES = {
  text: 'text',
  date: 'date',
  checkbox: 'checkbox',
  select: 'select',
  numeric: 'numeric',
  formula: 'formula',
  signature: 'signature',
  switch: 'switch',
  autocomplete: 'autocomplete',
  image: 'image'
}

export const HINTS_BY_TYPE = {
  text: 'Enter value',
  date: 'Select date',
  select: 'Select variant from list',
  numeric: 'Numeric',
  formula: 'Formula',
  signature: 'Signature',
  switch: 'Yes / No',
  image: 'Image'
}

export const WIDTH_BY_TYPE = {
  text: TEXT_FIELD_DEFAULT_WIDTH,
  date: DATE_FIELD_DEFAULT_WIDTH,
  checkbox: CHECKBOX_DEFAULT_SIZE,
  select: SELECT_FIELD_DEFAULT_WIDTH,
  numeric: NUMERIC_FIELD_DEFAULT_WIDTH,
  formula: TEXT_FIELD_DEFAULT_WIDTH,
  signature: DATE_FIELD_DEFAULT_WIDTH,
  switch: SWITCH_FIELD_DEFAULT_WIDTH,
  autocomplete: AUTOCOMPLETE_FIELD_DEFAULT_WIDTH,
  image: IMAGE_DEFAULT_SIZE
}

export const HEIGHT_BY_TYPE = {
  checkbox: CHECKBOX_DEFAULT_SIZE,
  image: IMAGE_DEFAULT_SIZE
}

export const OPTIONS_BY_TYPE = {
  select: [],
  autocomplete: [
    { value: 'fullName', label: 'ПІБ (прізвище, імʼя, по батькові)' },
    { value: 'identity', label: 'РНОКПП (ІПН)' }
  ]
}
